'use strict';
/**
 * @param {emailId} emailId is the email of customer
 * @param {url} url is controller to be called
 * @param {productId} productId is the product for which BIS is subscribed
 */
function backInStockTrigger(emailId, url, productId) {
    $.ajax({
        url: url,
        type: 'post',
        dataType: 'json',
        data: { email: emailId, pid: productId },
        success: function (response) {
            if (response.status === 'success') {
                $('.email-alert-success-wrapper').removeClass('d-none');
                $('.email-alert-field-wrapper').addClass('d-none');
                $('.email-alert-heading:not(.successHeading)').addClass('d-none');
                $('#emailtoalert').val('');
            }
        },
        error: function (err) {
            console.log(err);
            $('#emailtoalert').addClass('field-error');
            $('.emailToAlertError').removeClass('d-none');
        }
    });
}
$('#emailalertBTN').on('click', function () {
    var email = $('#emailtoalert').val();
    var regex = /^[\w.%+-]+@[\w.-]+\.[\w]{2,6}$/;
    if (regex.test(email) === true) {
        var url = $('.inStock-alert').data('url');
        var pid = $('.selected-variant-pid').val();
        backInStockTrigger(email, url, pid);
        $('.emailToAlertError').addClass('d-none');
    } else {
        $('#emailtoalert').addClass('field-error');
        $('.emailToAlertError').removeClass('d-none');
    }
});
